import React, { useState, useEffect } from 'react';
import Plotly from 'plotly.js-dist-min';
import html2canvas from 'html2canvas';
import jsPdf from 'jspdf';
import { default as t } from '../../../utils/i18n';
import './recommendation-details-modal.scss';
import { CampaignDetailsHeader } from '../../atoms';
import { ReactComponent as DownloadIcon } from '../../../assets/svg/Download-icon.svg';
import config from '../../../utils/config';
import axiosStat from 'axios';
import fileDownload from 'js-file-download';

import axios from '../../../utils/axios';
const RecommendationDetailsModal = props => {
  const [recommendationModalView, setRecommendationModalView] = useState(null);
  const HELP_SUPPORT_LINK = config.get('help', 'support_link_performance');

  const handleDownload = (url, filename) => {
    const userGuideUrl = url.replace(/\{(.*?)\}/gi, t('dashboard.link.helpAndSupport', true));

    const api = axiosStat.create({
      baseURL: axios.defaults.baseURL.slice(0, -4),
    });

    api
      .get(userGuideUrl, {
        responseType: 'blob',
      })
      .then(res => {
        fileDownload(res.data, filename);
      });
  };
  const handleBackClick = () => {
    document.body.style.overflow = 'auto';
    setTimeout(() => {
      props.handleModalBackClick();
    }, 1000);
    setRecommendationModalView(!recommendationModalView);
  };

  const handleDownloadModalSSClick = () => {
    const icon = document.querySelector('.download-modal-icon');
    icon.classList.add('active');
    const fileName = 'Insight details';
    var testdiv = document.getElementById('modal-snapshot-container');
    html2canvas(testdiv, {
      scrollX: -window.scrollX,
      scrollY: -window.scrollY,
      windowWidth: document.documentElement.offsetWidth,
      windowHeight: document.documentElement.offsetHeight, // There is no deviation from the top so there is no need to modify
      backgroundColor: '#F3F3F3',
      allowTaint: true,
      useCORS: true,
    }).then(canvas => {
      const image = canvas.toDataURL('image/jpeg', 1.0);
      const doc = new jsPdf('p', 'px', 'a4');
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      const widthRatio = pageWidth / canvas.width;
      const heightRatio = pageHeight / canvas.height;
      const ratio = widthRatio > heightRatio ? heightRatio : widthRatio;

      const canvasWidth = canvas.width * ratio;
      const canvasHeight = canvas.height * ratio;

      const marginX = (pageWidth - canvasWidth) / 2;
      const marginY = (pageHeight - canvasHeight) / 2;

      doc.addImage(image, 'JPEG', marginX, marginY, canvasWidth, canvasHeight);
      doc.save(`${fileName}.pdf`);
      icon.classList.remove('active');
    });
  };

  useEffect(() => {
    setRecommendationModalView(true);
    document.body.style.overflow = 'hidden';
    props.insightDetails.insight_details.about_this_insight =
      props?.insightDetails?.insight_details?.about_this_insight
        .replace(/'(.*?)'/g, function myFunction(x) {
          x = '<span>' + x + '</span>';
          return x;
        })
        .replaceAll("'", '');
    generateGraphData();
  }, []);

  const regessionOptions = {
    editable: false,
    displaylogo: false,
    displayModeBar: false,
    scrollZoom: false,
    showLink: false,
    modeBarButtonsToRemove: [
      'sendDataToCloud',
      'zoom2d',
      'pan',
      'pan2d',
      'autoScale2d',
      'lasso2d',
      'autoScale2d',
      'resetScale2d',
      'toggleSpikelines',
      'dragmode',
    ],
  };
  const generateGraphData = () => {
    const trace1 = {
      x: [],
      // y:[],
      name: '',
      hovertemplate: [],
      orientation: 'h',
      marker: {
        color: 'rgba(225, 190, 106, 0.6)',
        width: 1,
      },
      type: 'bar',
    };

    const trace2 = {
      x: [],
      // y:[],
      name: '',
      hovertemplate: [],
      orientation: 'h',
      type: 'bar',
      marker: {
        color: 'rgba(64, 176, 166, 0.6)',
        width: 1,
      },
    };

    props?.insightDetails?.insight_details?.extened_suggestions?.slice(0).reverse()
      .map((rowData, index) => {
        if (props?.insightDetails?.kpiUnit.length){
        trace2.x.push(rowData.predicted_impact_on_KPI*100);
        } else {
          trace2.x.push(rowData.predicted_impact_on_KPI);
        } 
        trace2.hovertemplate.push(
          'Suggested Setting ' + decimalCount(rowData.predicted_impact_on_KPI)
        );
        trace1.hovertemplate.push(
          'Current Setting ' + decimalCount(rowData.no_optimization_prediction)
        );
        // trace2.y.push(index+1);
        // trace1.y.push(index+1);
        if (props?.insightDetails?.kpiUnit.length){
        trace1.x.push(rowData.no_optimization_prediction*100);
        }else {
          trace1.x.push(rowData.no_optimization_prediction);
        }
      });

    const layout = {
      //title: 'Impact on selected KPI',
      barmode: 'stack',
      yaxis: {
        gridcolor: '#E7E7E7',
        tickmode: 'linear',
        tick0: 0.5,
        dtick: 1,
      },
      xaxis: {
        gridcolor: '#E7E7E7',
        zerolinecolor: '#E7E7E7',
      },
      width: 350,
      height: props?.insightDetails?.insight_details?.extened_suggestions?.length * 49.3 + 20,
      showlegend: false,

      margin: {
        l: 2,
        r: 0,
        b: 20,
        t: 0,
        // pad: 10,
      },
      bargap: 0.55,
    };

    setTimeout(() => {
      const data = [trace1, trace2];
      Plotly.newPlot('myDiv1', data, layout, regessionOptions);
      const layout2 = layout;
      layout2.height = props?.insightDetails?.insight_details?.extened_suggestions?.length * 105 + 20;
      Plotly.newPlot('myDiv2', data, layout2, regessionOptions);
    }, 1000);
  };

  const decimalCount = num => {
    // Convert to String
    const numStr = String(num);
    // String Contains Decimal
    if (numStr.includes('.')) {
      const length = numStr.split('.')[1].length;
      if (props?.insightDetails?.kpiUnit.length) {
        return num ? num.toFixed(length).toLocaleString() * 100 : '';
      } else {
        return num ? num.toFixed(length).toLocaleString() : '';
      }
    }
    // String Does Not Contain Decimal
    if (props?.insightDetails?.kpiUnit.length) {
      return num ? num.toLocaleString() * 100 : '' ;
    } else {
      return num ? num.toLocaleString() : '' ;
    }
  };

  return (
    <>
      <div className={`attribute-detail-view-overlay ${recommendationModalView ? 'show' : 'hide'}`}>
        <div className="attribute-detail-view">
          <div className="attribute-detail-view-header">
            <span className="attribute-detail-view-headertext">
              {t('download.pdf.info.question')}
            </span>
            <button
              className="download-snapshot"
              onClick={() => handleDownload(HELP_SUPPORT_LINK, 'help.pdf')}
            >
              <i className="eva eva-message-circle-outline"></i>

              {t('download.pdf.button.label')}
            </button>
          </div>
          <div className="attribute-detail-view-buttongroup">
            <button className="return-insights" onClick={() => handleBackClick()}>
              <i className="eva  eva-arrow-ios-back-outline"></i>
              {t('user.buttonText.back')}
            </button>
            <DownloadIcon className="download-modal-icon" />
            <button className="download-snapshot" onClick={() => handleDownloadModalSSClick()}>
              <i className="eva eva-camera-outline"></i>
              {t('download.snapshot.button.label')}
            </button>
          </div>
          <div>
            <div className="campaign">
              <CampaignDetailsHeader campaignDetails={props?.insightDetails?.campaign_Details} />
            </div>
            <div className="attribute-detail-view-title">
              <span className="title-text">{t('insight.details')}</span>
            </div>

            <div className="attribute-detail-view-summarygroup">
              <div className="recommend-distribute-1-3 attribute-detail-view-summarygroup-item">
                <div className="summarygroup-item">
                  <div className="summarygroup-item-title">{t('selected.kpi')}</div>
                  <div className="summarygroup-item-text">
                    {props?.insightDetails?.selected_kpi}
                  </div>
                </div>
              </div>
              <div className="recommend-distribute-1-3 attribute-detail-view-summarygroup-item">
                <div className="summarygroup-item">
                  <div className="summarygroup-item-title">{t('kpi.without.optmi')}</div>
                  <div className="summarygroup-item-text">
                    {decimalCount(props?.insightDetails?.insight_details?.no_optimization_prediction)}{' '}
                    {props?.insightDetails?.kpiUnit.length ? '%' : ''} ({t('predicted.lifetime')})
                  </div>
                </div>
              </div>
              <div className="recommend-distribute-1-3 attribute-detail-view-summarygroup-item">
                <div className="summarygroup-item">
                  <div className="summarygroup-item-title">{t('kpi.with.optmi')}</div>
                  <div className="summarygroup-item-text">
                    {decimalCount(props?.insightDetails?.insight_details?.optimization_prediction)}{' '}
                    {props?.insightDetails?.kpiUnit.length ? '%' : ''} ({t('predicted.lifetime')})
                  </div>
                </div>
              </div>
            </div>
            <div className="attribute-detail-view-data">
              <div className="recommend-distribute-2-3">
                <div className="attribute-detail-view-summarygroup-item">
                  <div className="graph-view-heading">
                    <div className="summarygroup-item-title">{t('impact.on.selected')}</div>
                  </div>
                  <div className="graph-view">
                    <div>
                      <div className="flex-class">
                        <div className="data-div info-div left-part">
                          <div className="header-1">
                            <div>{t('rec.rank')}</div>
                            <div>{t('rec.attribute')}</div>
                          </div>
                          {props?.insightDetails?.insight_details?.extened_suggestions?.map(
                            (row, index) => {
                              return (
                                  <div key={row.rank.toString()} className="row-div left-div">
                                    <div>{row.rank}</div>

                                    <div className="title-case">{row.title}</div>
                                  </div>
                              );
                            }
                          )}
                          <div>
                            <span style={{ visibility: 'hidden' }}> Extra div</span>
                          </div>
                        </div>

                        <div className="data-div">
                          <div className="header-2">
                            {t('predicted.kpi')}
                          </div>
                          <div id="myDiv1" className="chart-div"></div>
                        </div>
                        <div className="data-div info-div">
                          <div className="header-3">
                            <div>{t('current.setting')}</div>
                            <div>{t('suggested.setting')}</div>
                            <div
                              className="long-name"
                              title={t('predicetd.percent')}
                            >
                              {t('predicetd.percent')}
                            </div>
                            <div>{t('predicted.id')}</div>
                          </div>
                          {props?.insightDetails?.insight_details?.extened_suggestions?.map(
                            (row, index) => {
                              return (
                                 <div key={index+'right'} className="row-div right-div">
                                    <div title={row.current_setting}>{row.current_setting}</div>
                                    <div title={row.suggested_setting}>{row.suggested_setting}</div>
                                    <div title={row.predicted_impact_percent + '%'}>
                                      {row.predicted_impact_percent + '%'}
                                    </div>
                                    <div title={row.Id + '/' + row.level}>
                                      {row.Id}/{row.level}
                                    </div>
                                  </div> 
                              );
                            }
                          )}
                          <div>
                            <span style={{ visibility: 'hidden' }}> Extra div</span>
                          </div>
                        </div>
                      </div>
                      <div className='metric'>
                        { props?.insightDetails?.kpiUnit.length > 0 ? '(Percentage)' : props?.insightDetails?.insight_details?.account_currency ? 
                        '('+props?.insightDetails?.insight_details?.account_currency+')' : ''}

                      </div>
                    </div>
                  </div>
                  <div className="graph-detail-view">
                    <h4>{t('details.attribute.graph.detail.heading')}</h4>
                    <p>{t('rec.details.graph.text')} </p>
                  </div>
                </div>

                <div className="recommend-distribute-1-3">
                  <div className="attribute-detail-view-summarygroup-item">
                    <div className="summarygroup-item-title">
                      {t('detail.attribute.modal.about.insight')}
                    </div>
                    <div
                      className="insight-text"
                      dangerouslySetInnerHTML={{
                        __html: props?.insightDetails?.insight_details?.about_this_insight,
                      }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* snaoshot HTML */}
          <div id="modal-snapshot-container">
            <div className="campaign">
              <CampaignDetailsHeader campaignDetails={props?.insightDetails?.campaign_Details} />
            </div>
            <div className="attribute-detail-view-title">
              <span className="title-text">{t('insight.details')}</span>
            </div>

            <div className="attribute-detail-view-summarygroup">
              <div className="recommend-distribute-1-3 attribute-detail-view-summarygroup-item">
                <div className="summarygroup-item">
                  <div className="summarygroup-item-title">{t('selected.kpi')}</div>
                  <div className="summarygroup-item-text">
                    {props?.insightDetails?.selected_kpi}
                  </div>
                </div>
              </div>
              <div className="recommend-distribute-1-3 attribute-detail-view-summarygroup-item">
                <div className="summarygroup-item">
                  <div className="summarygroup-item-title">{t('kpi.without.optmi')}</div>
                  <div className="summarygroup-item-text">
                    {decimalCount(props?.insightDetails?.insight_details?.no_optimization_prediction)}{' '}
                    ({t('predicted.lifetime')})
                  </div>
                </div>
              </div>
              <div className="recommend-distribute-1-3 attribute-detail-view-summarygroup-item">
                <div className="summarygroup-item">
                  <div className="summarygroup-item-title">{t('kpi.with.optmi')}</div>
                  <div className="summarygroup-item-text">
                    {(props?.insightDetails?.insight_details?.optimization_prediction)}{' '}
                    ({t('predicted.lifetime')})
                  </div>
                </div>
              </div>
            </div>
            <div className="attribute-detail-view-data">
              <div className="recommend-distribute-2-3">
                <div className="attribute-detail-view-summarygroup-item">
                  <div className="graph-view-heading">
                    <div className="summarygroup-item-title">{t('impact.on.selected')}</div>
                  </div>
                  <div className="graph-view">
                    <div>
                      <div className="flex-class">
                        <div className="data-div info-div left-part">
                          <div className="header-1">
                            <div>{'Rank'}</div>
                            <div>{'Attribute'}</div>
                          </div>
                          {props?.insightDetails?.insight_details?.extened_suggestions?.map(
                            (row, index) => {
                              return (
                                  <div key={index +'1'} className="row-div left-div">
                                    <div>{row.rank}</div>

                                    <div className="title-case">{row.title}</div>
                                  </div>
                              );
                            }
                          )}
                          <div>
                            <span style={{ visibility: 'hidden' }}> Extra div</span>
                          </div>
                        </div>

                        <div className="data-div">
                          <div className="header-2">
                          {t('predicted.kpi')}
                          </div>
                          <div id="myDiv2" className="chart-div"></div>
                        </div>
                        <div className="data-div info-div">
                          <div className="header-3">
                          <div>{t('current.setting')}</div>
                            <div>{t('suggested.setting')}</div>
                            <div
                              className="long-name"
                              title={t('predicted.impact.percentage.graph')}
                            >
                              {t('predicted.impact.percentage.graph')}
                            </div>
                            <div>{t('predicted.id')}</div>
                          </div>
                          {props?.insightDetails?.insight_details?.extened_suggestions?.map(
                            (row, index) => {
                              return (
                                  <div key={index+'right1'} className="row-div right-div">
                                    <div title={row.current_setting}>{row.current_setting}</div>
                                    <div title={row.suggested_setting}>{row.suggested_setting}</div>
                                    <div title={row.predicted_impact_percent + '%'}>
                                      {row.predicted_impact_percent + '%'}
                                    </div>
                                    <div title={row.Id + '/' + row.level}>
                                      {row.Id}/{row.level}
                                    </div>
                                  </div>
                              );
                            }
                          )}
                          <div>
                            <span style={{ visibility: 'hidden' }}> Extra div</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='metric'>
                    { props?.insightDetails?.kpiUnit.length > 0 ? '(Percentage)' : props?.insightDetails?.insight_details?.account_currency ? 
                        '('+props?.insightDetails?.insight_details?.account_currency+')' : ''}
                      </div>
                  </div>
                  <div className="graph-detail-view">
                    <h4>{t('details.attribute.graph.detail.heading')}</h4>
                    <p>{t('rec.details.graph.text')} </p>
                  </div>
                </div>

                <div className="recommend-distribute-1-3">
                  <div className="attribute-detail-view-summarygroup-item">
                    <div className="summarygroup-item-title">
                      {t('detail.attribute.modal.about.insight')}
                    </div>
                    <div
                      className="insight-text"
                      dangerouslySetInnerHTML={{
                        __html: props?.insightDetails?.insight_details?.about_this_insight,
                      }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* slide modal view ends */}
    </>
  );
};

export default RecommendationDetailsModal;
